import { render } from "./group_compliance_rules.html?vue&type=template&id=0275a75c&external"
import script from "./group_compliance_rules.js?vue&type=script&lang=js&external"
export * from "./group_compliance_rules.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__